import SettingsPanel from './SettingsPanel';
import { CompanyProvider } from '../../contexts/CompanyContext';
import { useSettingsState } from './useSettingsState';

function SettingsSection({
    companyId,
    companyInfo,
    setCompanyInfo,
    marketplaces,
    workspaces,
    companyUsers,
    setActiveSection,
    loadMarketplaces,
    loadWorkspaces,
    settingsTab,
    setSettingsTab,
    openProjectModal
}) {
    const settingsValue = useSettingsState({
        companyId,
        companyInfo,
        setCompanyInfo,
        marketplaces,
        workspaces,
        companyUsers,
        setActiveSection,
        loadMarketplaces,
        loadWorkspaces,
        settingsTab,
        setSettingsTab,
        openProjectModal
    });

    return (
        <div className="settings-layout">
            <CompanyProvider value={settingsValue}>
                <SettingsPanel />
            </CompanyProvider>
        </div>
    );
}

export default SettingsSection;
